import type {
  CreateProcedurePayloadType,
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';
import { notEmptyValidation } from 'security-app/components/common/FormUtils/commonValidations';

export type EventProcedureFormErrorsType = {
  title?: string;
  description?: string;
  steps?: string;
};

export const INIT_EVENT_PROCEDURE: CreateProcedurePayloadType = {
  title: '',
  description: '',
  steps: [],
  share_request: {},
};

export const validateTitle = (value: string) => (notEmptyValidation(value) ? undefined : 'Title is required');

export const validations = (values: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => {
  const errors: EventProcedureFormErrorsType = {};

  const invalidTitle = validateTitle(values.title);

  if (invalidTitle) errors.title = invalidTitle;

  return errors;
};
